import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.DATA_PURGE }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.DATA_PURGE, permission: Permission.DELETE });
    context.validatePermissions({ isAllowed, preload });
  },
});
